import React from "react";
import { graphql } from "gatsby";
import styled from "styled-components";
import NavBar from "../../components/NavBar";
import Footer from "../../components/footer";
import { motion } from "framer-motion";
import { MDXRenderer } from "gatsby-plugin-mdx";
import Layout from "../../components/globalStyle";
const MainDiv = styled.div`
  text-align: center;
  margin: 2rem auto;
  width: 80%;
`;

const stagger = {
  animate: {
    transition: {
      staggerChildren: 0.2,
    },
  },
};

const variantEmpty = {
  initial: {},
  animate: {},
};

const variantIndex = {
  initial: { y: -40, opacity: 0 },
  animate: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.5,
    },
  },
};

export default function DynamicPageProject({ data }) {
  return (
    <Layout>
      <motion.div
        exit={{ opacity: 0 }}
        initial='initial'
        animate='animate'
        variants={variantEmpty}>
        <motion.div variants={stagger}>
          <NavBar variants={variantIndex}></NavBar>
          <MainDiv>
            <MDXRenderer>{data.mdx.body}</MDXRenderer>
          </MainDiv>
        </motion.div>
        <Footer />
      </motion.div>
    </Layout>
  );
}

export const query = graphql`
  query ($id: String) {
    mdx(id: { eq: $id }) {
      frontmatter {
        title
        date(formatString: "MMMM D, YYYY")
      }
      body
    }
  }
`;
